import React, { useEffect } from "react";
import {
    Utensils,
    Car,
    Bus,
    Accessibility,
    ChevronRight,
} from "lucide-react";
import { useClara } from "../contexts/ClaraContext";
import { TRANSPORT_OPTIONS } from "../data/sampleData";

const ICONS = { Utensils, Car, Bus, Accessibility };

export const Transportation = () => {
    const { speak } = useClara();

    useEffect(() => {
        speak("Food and Rides. Pick a service and Clara will help you book.");
    }, [speak]);

    const handlePick = (opt) => {
        speak(
            `Opening ${opt.name}. ${opt.desc}. Tell me where you'd like to go or what you'd like to order.`,
        );
    };

    return (
        <ul className="space-y-3" data-testid="transport-list">
            {TRANSPORT_OPTIONS.map((opt) => {
                const Icon = ICONS[opt.icon] || Car;
                return (
                    <li key={opt.id}>
                        <button
                            type="button"
                            onClick={() => handlePick(opt)}
                            aria-label={`${opt.name}: ${opt.desc}`}
                            data-testid={`transport-${opt.id}`}
                            className="w-full bg-white rounded-2xl p-4 flex items-center gap-4 border border-[#0A3D7A]/10 shadow-[0_2px_12px_rgba(10,61,122,0.06)] hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(10,61,122,0.12)] hover:border-[#0A3D7A]/25 transition-all text-left min-h-[80px]"
                        >
                            <span
                                aria-hidden="true"
                                className="shrink-0 w-12 h-12 rounded-2xl bg-[#0A3D7A] text-white flex items-center justify-center"
                            >
                                <Icon className="w-6 h-6" strokeWidth={2.2} />
                            </span>
                            <span className="flex-1 min-w-0">
                                <span className="block font-display font-bold text-lg text-[#1A1A2E] leading-tight">
                                    {opt.name}
                                </span>
                                <span className="block text-sm text-[#5A5A6E]">
                                    {opt.desc}
                                </span>
                            </span>
                            <ChevronRight
                                className="w-5 h-5 text-[#0A3D7A]"
                                aria-hidden="true"
                            />
                        </button>
                    </li>
                );
            })}
        </ul>
    );
};

export default Transportation;
